import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { generateChartColors } from '../Helper/chartColorHelper';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);



export default function LineChart({ data, height, ...props }) {
  if (!data || data.length === 0) return null;

  // Deteksi key data secara dinamis (kecuali label dan metadata)
  const keys = Object.keys(data[0]).filter(k => 
    k !== "label" && k !== "total" && k !== "id" && k !== "createdAt" && k !== "updatedAt"
  );
  const isComparison = keys.length > 1;

  const config = typeof props.tableConfig === 'string' ? JSON.parse(props.tableConfig) : (props.tableConfig || {});
  
  // Aktifkan dual axis HANYA jika dicentang di konfigurasi (default: false)
  const isDual = (props.useDualAxis === true || config.useDualAxis === true) && isComparison;

  const yTitle = props.yAxisTitle || config.yAxisTitle || keys[0] || "Nilai";

  const chartColors = generateChartColors(keys.length);
  
  const chartData = {
    labels: data.map(d => d.label),
    datasets: keys.map((key, index) => ({
      label: key,
      data: data.map(d => d[key]),
      yAxisID: isDual ? (index === 0 ? 'y' : 'y1') : 'y',
      borderColor: chartColors[index % chartColors.length],
      backgroundColor: chartColors[index % chartColors.length],
      borderWidth: 3,
      tension: 0.4,
      pointRadius: 4,
      pointBackgroundColor: "#fff",
      pointBorderWidth: 2,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: isComparison,
        position: 'top',
        labels: {
          boxWidth: 12,
          font: { size: 11 }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        titleColor: '#111',
        bodyColor: '#666',
        borderColor: '#eee',
        borderWidth: 1,
        padding: 10,
        cornerRadius: 8,
      },
    },
    scales: {
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        beginAtZero: true,
        title: {
          display: true,
          text: yTitle,
          color: chartColors[0],
          font: { size: 11, weight: 'bold' }
        },
        ticks: { font: { size: 10 }, color: "#6b7280" },
        grid: { color: "#f3f4f6" }
      },
      y1: {
        type: 'linear',
        display: isDual,
        position: 'right',
        beginAtZero: true,
        title: {
          display: true,
          text: keys.length > 1 ? (keys.slice(1).join(" & ")) : "",
          color: chartColors[1 % chartColors.length],
          font: { size: 11, weight: 'bold' }
        },
        ticks: { font: { size: 10 }, color: "#6b7280" },
        grid: { drawOnChartArea: false }, // avoid overlapping grid lines
      },
      x: {
        ticks: {
          font: { size: 10 },
          color: "#6b7280",
          maxRotation: 25,
          minRotation: 25
        },
        grid: { display: false }
      },
    },
  };

  return (
    <div style={{ height: height, width: '100%' }}>
      <Line options={options} data={chartData} />
    </div>
  );
}
